export const CONFIG = {
  API: {
    DEV: {
      LOCATION: 'https://dev-api.datastop.io/locations/auto-complete',
      MAJOR:
        'https://dev-api.datastop.io/institutions/auto-complete-instructional-programs',
      OCCUPATION: 'https://dev-api.datastop.io/occupations/auto-complete'
    },
    PROD: {
      LOCATION: 'https://api.datastop.io/locations/auto-complete',
      MAJOR:
        'https://api.datastop.io/institutions/auto-complete-instructional-programs',
      OCCUPATION: 'https://api.datastop.io/occupations/auto-complete'
    }
  }
};
